<div class="search-wrapper" fxLayout="row" [ngClass]="{ 'focus': focused, 'has-input': input }" fxFlex
  (furyClickOutside)="closeDropdown()">
  <mat-icon class="search-icon">search</mat-icon>
  <input type="search"
    autocomplete="off"
    spellcheck="false"
    class="search-input"
    [(ngModel)]="input"
    (keyup)="onKeyup($event)"
    (focus)="openDropdown()"
    placeholder="Search...">

  <div class="search-dropdown">
    @if (input) {
      <div class="content results" fxLayout="column">
        <div class="heading" fxLayout="row" fxLayoutAlign="start center">
          <mat-icon class="icon">search</mat-icon>
          Search results for: {{ input }}
        </div>
        @for (item of searchList; track (item.id || item.link || item.name || $index)) {
          <div class="items">
            <div class="item" matRipple [routerLink]="[item.link]">{{item.name}}</div>
          </div>
        }
      </div>
    }

    @if (!input) {
      <div class="content recents" fxLayout="row">
        <div class="recently" fxLayout="column" fxFlex>
          <div class="heading" fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="icon">restore</mat-icon>
            Recently Visited
          </div>
          <div class="items">
            @for (item of recentlyVisited; track (item.id || item.routeOrFunction || item.name || $index)) {
              <div class="item" matRipple [routerLink]="item.routeOrFunction"
                (click)="closeDropdown()">{{ item.name }}
              </div>
            }
          </div>
        </div>
        <div class="frequently" fxLayout="column" fxFlex fxFlexOffset="16px">
          <div class="heading" fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="icon">youtube_searched_for</mat-icon>
            Frequently Visited
          </div>
          <div class="items">
            @for (item of frequentlyVisitedList; track (item.id || item.link || item.name || $index)) {
              <div class="item" matRipple [routerLink]="[item.link]">
                {{ item.name}}
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
